import entityLogRepository from '@/repository/generatedRepository/entityLogRepository'
import TableOptions from '@/models/TableOptions'
import { prepareFilters } from '@/helpers/filters'
import { defaultFilters } from '@/models/EntityLog/helpers'
import { buildLogRows } from '@/models/EntityLog/transforms'
import { downloadExportFile } from '@/helpers/export'

const state = {
  list: [],
  filters: { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  list: state => state.list,
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  preparedRows: state => buildLogRows(state.list, state.filters.properties),
}

const actions = {
  async loadData(context, payload) {
    const filters = {
      sortBy: context.state.filters.sortBy,
      sortDesc: context.state.filters.sortDesc,
      ...payload,
    }
    context.commit('setFilters', filters)
    const { data } = await entityLogRepository.list(prepareFilters(filters))
    context.commit('setList', { data, filters })
  },
  async loadExportFile(context, payload) {
    const filters = {
      sortBy: context.state.filters.sortBy,
      sortDesc: context.state.filters.sortDesc,
      ...payload,
    }
    await downloadExportFile(entityLogRepository.exportEntityLogToken(prepareFilters(filters)))
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = data.items || []
    state.tableOptions = new TableOptions(data.pagination || null, filters)
  },
  setFilters(state, payload) {
    state.filters = { ...payload }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
